<template>
  <div class="message-standard">
      <div class="header"><i style="display: inline-block;width: 2px; height: 14px; background-color: #0A80E6;border-radius: 6px;margin-right: 5px;margin-top: 8px;float: left;"></i> <span style="float: left">预警消息</span><span style="float: right;margin-right: 20px;cursor: pointer;" @click="rollback"><a-icon type="rollback" style="color: #0A80E6;"/> 返回</span></div>
       <div class="title"><p class="til">【{{message.title}}】{{message.content}}</p> <span class="data">{{message.time}}</span></div>
       <div class="content">
            <p style="font-size: 14px">当前，{{standardDetail.datarangeName}}剩余未换版的证书有 <i style="color: #D7837D;font-weight: 500;font-size: 20px;">{{standardDetail.certNum}}</i> 张，涉及到 <i v-if="standardDetail.list" style="color: #D7837D;font-weight: 500;font-size: 20px;">{{standardDetail.list.length}}</i><i v-else>0</i> 个标准的更替。 自新标准开始实施后一年内可以换证，逾期暂停，超过3个月将撤销证书。</p>
            <p style="color: rgb(162, 162, 162);font-size: 12px;margin: 10px 0 5px 0;">（此消息来源相关机构仅供参考，请以国家标准公开文件和具体认证机构信息为准）</p>
            <div class="list-box" v-if="standardDetail.list">
              <div v-for="(i, index) in standardDetail.list" :key="index">
                <ul>
                  <li>新标准号：<span style="color: #0A80E6;cursor: pointer" @click="goHref(i.url)">{{i.newStandard}}</span></li>
                  <li>发布日期：<span>{{i.publishTime | formatDate}}</span></li>
                  <li>代替旧标准：<span style="color: #D7837D;font-weight: 500;">{{i.oldStandard}}</span> <span style="color: #D7837D;font-weight: 500;">（待换证 {{i.certNum}} 张）</span></li>
                  <li>实施日期：<span>{{i.implementTime | formatDate}}</span></li>
                  <li>换版截止：<span>{{i.endTime | formatDate}}</span></li>
                  <li>剩余天数：<span>{{i.remainDays}}</span> 天</li>
                </ul>
              </div>
            </div>
          <div class="range-box" v-if="standardDetail.dataRangeInfo">
            <p>各事业部换版分布</p>
            <table>
              <tr v-for="(s, index) in standardDetail.dataRangeInfo" :key="index">
                <td>{{s.name}}</td><td>{{s.certNum}} 个</td>
              </tr>
            </table>
          </div>
        </div>
  </div>
</template>
<script>

import { getMessageStandard} from '@/api/message'
import {formatDate, dateDiff} from '@/utils/date';
import {getFileSuffix,isAssetTypeAnImage,isAssetTypeOther} from '@/utils/index'

export default {
  name: 'messageChange',
  components: {},
  data() {
    return {
      roleId: '',
      standardDetail: {},
      message: {}
    }
  },
  mounted() {
    this.roleId = this.$store.state.user.roles;
    let id = this.$route.query.id;
    this.getMessageStandard(id);
  },
  created() {
    this.$bus.$emit('reloadTop');
  },
  methods: {
    rollback() {
      this.$router.push('/user/informCenter');
    },
    getMessageStandard(id) {
      getMessageStandard(id)
        .then(res => {
          if (res) {
            this.message = res.message;
            this.standardDetail = res.standardReplace;
          }
        })
        .catch(error => {
          console.log(error);
        })
    },
    goHref(url) {
        window.open(url, '_blank');
    },
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
    dateDiff(time){
      return dateDiff(time);
    },
    spliceChinese(val) {
      if (val) {
        var reg = /[\u4e00-\u9fa5]/g;
        if (val.match(reg)) {
            return val.match(reg).join('');
          } else {
            return val;
          }
      }
    },
  },
}
</script>

<style lang="less" scoped>
 .message-standard {
     background-color: #fff;
     height: 100%;
     padding: 20px;
     .header {
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        border-bottom: 1px solid #c1c1c1;
        margin-bottom: 10px;
     }
     .title {
         .til {
            display: inline-block;
            width: 800px;
            font-weight: 600;
            font-size: 16px;
            overflow: hidden;/*超出部分隐藏*/
            white-space: nowrap;/*不换行*/
            text-overflow:ellipsis;
            vertical-align: middle;
            text-indent: 20px;
         }
         .data {
             font-size: 12px;
             color: #c1c1c1;
         }
     }
    .content {
        width: 100%;
        padding: 0 30px;
        .list-box {
            width: 500px;
            ul {
                background-color: #f2f2f2;
                margin-bottom: 20px;
                padding: 10px;
                li {
                height: 25px;
                line-height: 25px;
                font-size: 12px;
                text-indent: 15px;
                }
            }
            }
            .range-box {
                width: 500px;
                p {
                    height: 40px;
                    line-height: 40px;
                    background-color: #fafafa;
                    color: #000;
                    font-weight: 400;
                    text-indent: 15px;
                }
                table {
                    width: 100%;
                    tr {
                    border: 1px solid #f2f2f2;
                    height: 30px;
                    line-height: 30px;
                        td {
                            width: 50%;
                            text-align: center;
                        }
                    }
                }
            }
     }
  }
</style>

